import { render, staticRenderFns } from "./Products2.vue?vue&type=template&id=7b8f9edb&scoped=true&"
import script from "./Products2.vue?vue&type=script&lang=js&"
export * from "./Products2.vue?vue&type=script&lang=js&"
import style0 from "./Products2.vue?vue&type=style&index=0&id=7b8f9edb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8f9edb",
  null
  
)

export default component.exports